/* Genuine Suede — product page helpers (size system switch, ship dates, "Learn more" pills).
   Works on top of Dawn's "Product information" section; never touches the cart or variant logic. */
(function () {
  if (window.__gsProduct) return;
  window.__gsProduct = true;

  var UNIT_KEY = 'gs-size-unit';
  var UNITS = ['eu', 'usw', 'usm'];

  function readUnit() {
    try {
      var u = window.localStorage.getItem(UNIT_KEY);
      return UNITS.indexOf(u) > -1 ? u : 'eu';
    } catch (e) {
      return document.documentElement.getAttribute('data-gs-size-unit') || 'eu';
    }
  }

  function applyUnit(unit) {
    document.documentElement.setAttribute('data-gs-size-unit', unit);
    var buttons = document.querySelectorAll('.gs-units__btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-gs-unit') === unit ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.gs-units__btn');
    if (btn) {
      event.preventDefault();
      var unit = btn.getAttribute('data-gs-unit');
      if (UNITS.indexOf(unit) === -1) return;
      try { window.localStorage.setItem(UNIT_KEY, unit); } catch (e) {}
      applyUnit(unit);
      return;
    }

    var chip = event.target.closest && event.target.closest('[data-gs-chip]');
    if (chip) {
      var id = (chip.getAttribute('href') || '').replace(/^#/, '');
      var target = id && document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  });

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initShip(root) {
    var boxes = (root || document).querySelectorAll('[data-gs-ship]');
    if (!boxes.length || !window.Intl) return;
    var now = new Date();
    var longFmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    var shortFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var ship = Number(box.getAttribute('data-ship')) || 3;
      var min = Number(box.getAttribute('data-min')) || 6;
      var max = Number(box.getAttribute('data-max')) || 15;
      var shipText = box.querySelector('[data-gs-ship-text]');
      var etaText = box.querySelector('[data-gs-eta-text]');
      if (shipText) {
        shipText.innerHTML = 'Ships by <strong>' + longFmt.format(addBusinessDays(now, ship)) + '</strong>';
      }
      if (etaText) {
        etaText.innerHTML =
          'Est. delivery <strong>' +
          shortFmt.format(addBusinessDays(now, min)) +
          ' – ' +
          shortFmt.format(addBusinessDays(now, max)) +
          '</strong>';
      }
    }
  }

  function initChips(root) {
    var chips = (root || document).querySelectorAll('[data-gs-chip]');
    for (var i = 0; i < chips.length; i++) {
      var id = (chips[i].getAttribute('href') || '').replace(/^#/, '');
      var li = chips[i].closest('li');
      if (li) li.hidden = !(id && document.getElementById(id));
    }
    var navs = (root || document).querySelectorAll('.gs-pdp-chips');
    for (var j = 0; j < navs.length; j++) {
      navs[j].hidden = !navs[j].querySelector('li:not([hidden])');
    }
  }

  function init(root) {
    applyUnit(readUnit());
    initShip(root);
    initChips(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Dawn re-renders the variant picker after every change: keep the chosen size system.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { applyUnit(readUnit()); });
    }
  } catch (e) {}

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* ---------------------------------------------------------------------------------------------
   Single / Duo pack selector (snippets/gs-bundle.liquid)
   Pair #1 = Dawn's variant picker (its hidden input name="id"), Pair #2 = our picker.
   Duo adds both variants with one /cart/add.js request and refreshes/open Upcart (or Dawn's drawer).
   --------------------------------------------------------------------------------------------- */
(function () {
  if (window.__gsBundle) return;
  window.__gsBundle = true;

  function moneyInfo(sample) {
    var m = (sample || '').match(/\d[\d.,'\s  ]*\d|\d/);
    if (!m) return null;
    var num = m[0];
    var info = { prefix: sample.slice(0, m.index), suffix: sample.slice(m.index + num.length), dec: null, thou: '' };
    var intPart = num;
    var dm = num.match(/([.,])(\d{2})$/);
    if (dm && num.replace(/\D/g, '') === '1234567') {
      info.dec = dm[1];
      intPart = num.slice(0, -3);
    }
    var tm = intPart.match(/\D/);
    if (tm) info.thou = tm[0];
    return info;
  }

  function formatMoney(cents, info) {
    if (!info) return '$' + (cents / 100).toFixed(2);
    var v = info.dec ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
    var parts = v.split('.');
    var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, info.thou);
    return info.prefix + i + (info.dec && parts[1] ? info.dec + parts[1] : '') + info.suffix;
  }

  function setup(root) {
    if (!root || root.__gsReady) return;
    root.__gsReady = true;
    var pi = root.closest('product-info') || document;
    var pair2 = pi.querySelector('[data-gs-pair2]');
    var buy = pi.querySelector('[data-gs-duo-buy]');
    var info = moneyInfo(root.getAttribute('data-money'));
    var unit = root.getAttribute('data-unit') || 'Pair';
    var basePct = Number(root.getAttribute('data-duo-off')) || 0;
    var pct = basePct;
    var mode = 'single';
    var variants = [];
    try {
      variants = JSON.parse(pair2.querySelector('[data-gs-p2-variants]').textContent);
    } catch (e) {}
    var byId = {};
    variants.forEach(function (v) { byId[String(v[0])] = v; });

    var btn = buy && buy.querySelector('[data-gs-duo-atc]');
    var label = buy && buy.querySelector('[data-gs-duo-label]');
    var priceBox = buy && buy.querySelector('[data-gs-duo-pricebox]');
    var totalWas = buy && buy.querySelector('[data-gs-duo-total-was]');
    var total = buy && buy.querySelector('[data-gs-duo-total]');
    var note = buy && buy.querySelector('[data-gs-duo-note]');
    var errorEl = buy && buy.querySelector('[data-gs-duo-error]');
    var spin = buy && buy.querySelector('[data-gs-duo-spin]');

    function pair1() {
      var input = pi.querySelector('form[action*="/cart/add"] input[name="id"]');
      var v = input && byId[String(input.value)];
      if (!v) return null;
      return { id: v[0], price: v[4], compare: v[5], available: !!v[6] };
    }

    function fieldsets() {
      return pair2 ? Array.prototype.slice.call(pair2.querySelectorAll('fieldset[data-gs-p2-option]')) : [];
    }

    function selectedValues() {
      return fieldsets().map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function matches(v, vals) {
      for (var i = 0; i < vals.length; i++) {
        if (vals[i] !== null && v[1 + i] !== vals[i]) return false;
      }
      return true;
    }

    function unescapeHtml(s) {
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }

    // Size labels follow the EU / US W / US M switch (CSS shows the chosen system).
    function setLabel(el, input) {
      var eu = input.getAttribute('data-short');
      if (!eu) {
        el.textContent = unescapeHtml(input.value);
        return;
      }
      el.innerHTML = '';
      [['eu', 'EU ' + eu], ['usw', 'US W ' + input.getAttribute('data-usw')], ['usm', 'US M ' + input.getAttribute('data-usm')]].forEach(function (u) {
        var s = document.createElement('span');
        s.className = 'gs-size__v gs-size__v--' + u[0];
        s.textContent = u[1];
        el.appendChild(s);
      });
    }

    function refreshAvailability() {
      var vals = selectedValues();
      fieldsets().forEach(function (fs, idx) {
        fs.querySelectorAll('input[data-gs-p2-value]').forEach(function (input) {
          var probe = vals.slice();
          probe[idx] = unescapeHtml(input.value);
          var ok = variants.some(function (v) { return v[6] && matches(v, probe); });
          var cls = input.classList.contains('swatch-input__input') ? 'visually-disabled' : 'disabled';
          input.classList.toggle(cls, !ok);
        });
        var chosen = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-gs-p2-selected]');
        if (out) {
          if (chosen) setLabel(out, chosen);
          else out.textContent = '';
        }
      });
      var summary = pair2 && pair2.querySelector('[data-gs-pair2-summary]');
      if (summary) {
        var picked = fieldsets().map(function (fs) { return fs.querySelector('input:checked'); });
        if (picked.every(Boolean)) {
          summary.textContent = '';
          picked.forEach(function (c, i) {
            if (i) summary.appendChild(document.createTextNode(' · '));
            var span = document.createElement('span');
            setLabel(span, c);
            summary.appendChild(span);
          });
        }
      }
    }

    function pair2Variant() {
      var vals = selectedValues().map(function (v) { return v === null ? null : unescapeHtml(v); });
      if (vals.some(function (v) { return v === null; })) return undefined;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], vals)) return variants[i];
      }
      return null;
    }

    function update() {
      var v1 = pair1();
      var singleWas = root.querySelector('[data-gs-single-was]');
      var singlePrice = root.querySelector('[data-gs-single-price]');
      var duoWas = root.querySelector('[data-gs-duo-was]');
      var duoEach = root.querySelector('[data-gs-duo-each]');
      var badge = root.querySelector('[data-gs-duo-badge]');
      if (v1) {
        singlePrice.textContent = formatMoney(v1.price, info);
        if (v1.compare > v1.price) {
          singleWas.textContent = formatMoney(v1.compare, info);
          singleWas.hidden = false;
        } else {
          singleWas.hidden = true;
        }
        var each = v1.price - Math.round((v1.price * pct) / 100);
        duoEach.textContent = formatMoney(each, info);
        duoWas.textContent = formatMoney(v1.price, info);
        duoWas.hidden = pct <= 0;
      }
      if (badge) {
        badge.hidden = pct <= 0;
        badge.textContent = 'Save ' + pct + '%';
      }
      if (note) {
        note.hidden = pct <= 0;
        note.textContent = pct + '% off both pairs, applied automatically in your cart.';
      }
      if (!btn) return;
      refreshAvailability();
      var v2 = pair2Variant();
      var ready = false;
      if (!v1) {
        label.textContent = 'Select ' + unit + ' #1';
      } else if (!v1.available) {
        label.textContent = unit + ' #1 is sold out';
      } else if (v2 === undefined) {
        label.textContent = 'Select ' + unit + ' #2';
      } else if (!v2 || !v2[6]) {
        label.textContent = unit + ' #2 is sold out';
      } else {
        ready = true;
        label.textContent = 'Add 2 pairs to cart';
      }
      btn.disabled = !ready;
      if (ready) {
        var sum = v1.price + v2[4];
        var discounted = sum - Math.round((sum * pct) / 100);
        total.textContent = formatMoney(discounted, info);
        totalWas.textContent = formatMoney(sum, info);
        totalWas.hidden = pct <= 0;
        priceBox.hidden = false;
      } else {
        priceBox.hidden = true;
      }
    }

    function setMode(next) {
      mode = next;
      pi.classList.toggle('gs-duo', mode === 'duo');
      if (pair2) pair2.hidden = mode !== 'duo';
      if (buy) buy.hidden = mode !== 'duo';
      root.querySelectorAll('.gs-pack').forEach(function (card) {
        var input = card.querySelector('input');
        card.classList.toggle('is-selected', !!input && input.checked);
      });
      update();
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.name && event.target.name.indexOf('gs-pack') === 0) setMode(event.target.value);
    });
    if (pair2) pair2.addEventListener('change', update);

    // Read the live Upcart reward for 2 items (the discount the cart really applies).
    function syncUpcart() {
      try {
        if (typeof window.upcartGetRewards !== 'function') return false;
        var r = window.upcartGetRewards();
        var tiers = (r && r.tiers) || [];
        var two = null;
        tiers.forEach(function (t) {
          if (Number(t.itemCount) <= 2 && (!two || Number(t.itemCount) > Number(two.itemCount))) two = t;
        });
        var found = two && String(two.rewardDescription || '').match(/(\d+(?:\.\d+)?)\s*%/);
        pct = found ? Number(found[1]) : 0;
        update();
        return true;
      } catch (e) {
        return false;
      }
    }
    var tries = 0;
    (function waitUpcart() {
      if (syncUpcart()) return;
      if (++tries < 20) return setTimeout(waitUpcart, 500);
      // No Upcart on the page: there is no automatic 2-pair discount, so show none.
      pct = 0;
      update();
    })();

    function setBusy(busy) {
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      btn.classList.toggle('loading', busy);
      if (spin) spin.classList.toggle('hidden', !busy);
      btn.disabled = busy || btn.disabled;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function refreshCartUi(cartData) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gs-duo', cartData: cartData });
        }
      } catch (e) {}
      if (typeof window.upcartRefreshCart === 'function') {
        return Promise.resolve(window.upcartRefreshCart()).catch(function () {}).then(function () {
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        });
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
        return fetch(window.location.pathname + '?sections=' + ids.join(','))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: null, sections: sections });
          })
          .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; });
      }
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return Promise.resolve();
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var v1 = pair1();
        var v2 = pair2Variant();
        if (!v1 || !v2 || !v1.available || !v2[6]) return update();
        var items =
          String(v1.id) === String(v2[0])
            ? [{ id: v1.id, quantity: 2 }]
            : [{ id: v1.id, quantity: 1 }, { id: v2[0], quantity: 1 }];
        showError('');
        setBusy(true);
        var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) {
              showError(res.data.description || res.data.message || 'Could not add to cart. Please try again.');
              return;
            }
            return refreshCartUi(res.data);
          })
          .catch(function () { showError('Could not add to cart. Please check your connection and try again.'); })
          .finally(function () {
            setBusy(false);
            update();
          });
      });
    }

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { update(); });
      }
    } catch (e) {}

    setMode('single');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gs-bundle]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
